interface PlanningPokerCardProps {
  id: string;
  level: number;
  name: string;
  description: string;
  isSelected?: boolean;
  isVoted?: boolean;
  disabled?: boolean;
  onClick?: () => void;
}

export const PlanningPokerCard = ({
  id,
  name,
  description,
  isSelected = false,
  isVoted = false,
  disabled = false,
  onClick,
}: Omit<PlanningPokerCardProps, 'level'>) => {
  const handleClick = () => {
    if (!disabled && onClick) {
      onClick();
    }
  };

  const imageUrl = `/apps/planning-poker/pp-card-${id}.png`;

  return (
    <div
      onClick={handleClick}
      className={`
        relative w-full max-w-[90px] cursor-pointer transition-all
        ${disabled ? 'cursor-not-allowed opacity-50' : 'hover:scale-105'}
        ${isSelected ? 'ring-2 ring-primary' : ''}
        ${isVoted ? 'ring-2 ring-green-500' : ''}
      `}
    >
      {/* Card Container */}
      <div className="relative aspect-[2/3] w-full overflow-hidden rounded-lg border-2 border-border bg-card shadow-lg">
        {/* Card Image */}
        <img
          src={imageUrl}
          alt={`${name}: ${description}`}
          title={description}
          className="h-full w-full object-cover"
          onError={(e) => {
            (e.target as HTMLImageElement).style.display = 'none';
          }}
        />

        {/* Title - Centered */}
        <div className="absolute inset-x-0 top-1/2 -translate-y-1/2 transform text-center pointer-events-none">
          <p className="text-3xl font-bold text-black drop-shadow-[0_2px_4px_rgba(255,255,255,0.8)]">{name}</p>
        </div>

        {/* Selected Indicator */}
        {isSelected && (
          <div className="pointer-events-none absolute inset-0 bg-primary/10 ring-2 ring-primary" />
        )}

        {/* Voted Indicator */}
        {isVoted && (
          <div className="absolute inset-0 flex items-center justify-center bg-green-500/20 pointer-events-none">
            <span className="text-2xl">✓</span>
          </div>
        )}
      </div>
    </div>
  );
};
